/*
 * Date: 2020-08-02 11:24:21
 * LastEditors: Mosuzi
 * LastEditTime: 2020-08-03 19:35:28
 * Description: In User Settings Edit
 * Author: Mosuzi
 */
export default {
  searchPlaceholder: '搜索待办主题',
  tabTitle: {
    myTodo: '我的待办',
    mySubmit: '我发起的',
    myParticipate: '我的已办'
  }
}
